import script from "./PointCloudViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PointCloudViewer.vue?vue&type=script&setup=true&lang=js"

import "./PointCloudViewer.vue?vue&type=style&index=0&id=fe8320aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe8320aa"]])

export default __exports__